export default __webpack_public_path__ + "static/media/aerosparkleLogo.64b1679e.png";